import { useMemo } from "react";
import { useLocation, useHistory } from "react-router";

export const setRefreshing = (history, location) => (refreshing) => {
  history.replace({
    ...location,
    state: {
      ...location.state,
      refreshing: refreshing,
    },
  });
};

const useRefreshing = () => {
  const location = useLocation();
  const history = useHistory();
  const isRefreshing = location?.state?.refreshing;

  const setRefreshingPartial = useMemo(() => {
    return setRefreshing(history, location);
  }, [history, location]);

  return [isRefreshing, setRefreshingPartial];
};

export default useRefreshing;
